import { createElementObject, createPathComponent, extendContext } from '@react-leaflet/core';
export const LeafletPolyline = createPathComponent(function createPolyline({ positions , ...options }, ctx) {
    const polyline = new window.L.polyline(positions, options);
    return createElementObject(polyline, extendContext(ctx, {
        overlayContainer: polyline
    }));
}, function updatePolyline(layer, props, prevProps) {
    if (props.positions !== prevProps.positions) {
        layer.setLatLngs(props.positions);
    }
});
